import Model from "../Model";

export interface TAdditionalCheckDetails {
  executionId: number;
  numberOfCandidates: number;
}

export interface IAdditionalCheckDetails extends TAdditionalCheckDetails {}

const AdditionalCheckDetails = Model(
  (model: TAdditionalCheckDetails): IAdditionalCheckDetails => {
    const _additionalCheckDetails: TAdditionalCheckDetails = Object.assign(
      {},
      model
    );

    return {
      get executionId() {
        return _additionalCheckDetails.executionId;
      },

      get numberOfCandidates() {
        return _additionalCheckDetails.numberOfCandidates;
      }
    };
  }
);

export default AdditionalCheckDetails;
